import { Delete } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import moment from "moment";
import { useMemo, useState } from "react";
import { tableConfig } from "../../../commons/table/tableConfig";
import { StyledResolucion } from "../../../styled/Prevencion";

const TrabajadoresSectorTable = ({ data, handleOpenFormularioTrabajador, handleDelete, handleCancelResolucion, handleNext }) => {
  const [rowSelection, setRowSelection] = useState({});

  const columns = useMemo(() => [
    {
      accessorKey: "cuil",
      header: "CUIL",
      filterVariant: 'text',
      size: 120,
    },
    {
      accessorKey: "nombreApellidoTrabajador",
      header: "Apellido y Nombre",
      filterVariant: 'text',
      size: 200,
    },
    {
      accessorKey: "nombreSector",
      header: "Sector",
      filterVariant: 'text',
      size: 150,
    },
    {
      accessorKey: "nombrePuesto",
      header: "Puesto",
      filterVariant: 'text',
      size: 150,
    },
    {
      accessorKey: "fechaIngreso",
      header: "Fecha Ingreso",
      filterVariant: 'text',
      size: 120,
      Cell: ({ cell }) => moment(cell.getValue()).format("DD/MM/YYYY"),
    },
    {
      accessorKey: "inicioContacto",
      header: "Inicio Contacto",
      filterVariant: 'text',
      size: 120,
      Cell: ({ cell }) => moment(cell.getValue()).format("DD/MM/YYYY"),
    },
    {
      accessorKey: "finContacto",
      header: "Fin Contacto",
      filterVariant: 'text',
      size: 120,
      Cell: ({ cell }) => cell.getValue() ? moment(cell.getValue()).format("DD/MM/YYYY") : "",
    },
  ], []);

  const handleDeleteSelected = () => {
    const selectedRows = Object.keys(rowSelection).map(
      (key) => data[Number(key)]
    );
    handleDelete(selectedRows);
    setRowSelection({});
  };

  const table = useMaterialReactTable({
    columns,
    data: data || [],
    enableRowSelection: true,
    state: {
      rowSelection,
    },
    onRowSelectionChange: setRowSelection,
    enableRowActions: true,
    positionActionsColumn: "last",
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: 'Operaciones',
        size: 120,
      },
    },
    renderRowActions: ({ row }) => (
      <Tooltip title="Editar Trabajador">
        <IconButton
          onClick={() => handleOpenFormularioTrabajador({ ...row.original, index: row.index })}
          color="primary"
          size="small"
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ),
    renderTopToolbarCustomActions: () => (
      <StyledResolucion.HeaderContainer>
        <StyledResolucion.TableTitle>
          Trabajadores por Sector
        </StyledResolucion.TableTitle>
      </StyledResolucion.HeaderContainer>
    ),
    renderBottomToolbarCustomActions: () => (
      <StyledResolucion.TableFooterButtonContainer>
        <Button
          color="primary"
          onClick={() => handleOpenFormularioTrabajador()}
        >
          Agregar
        </Button>
      </StyledResolucion.TableFooterButtonContainer>
    ),
    muiPaginationProps: {
      labelRowsPerPage: "Filas por página:",
      getItemAriaLabel: (type) => {
        if (type === 'first') return 'ir a la primera página';
        if (type === 'last') return 'ir a la última página';
        if (type === 'next') return 'ir a la página siguiente';
        return 'ir a la página anterior';
      },
      labelDisplayedRows: ({ from, to, count }) => `${from}-${to} de ${count}`,
    },
    localization: {
      ...MRT_Localization_ES,
      noRecordsToDisplay: "No hay datos que mostrar",
      MRT_RowsSelected: '{0} Fila(s) seleccionadas',
    },
    initialState: {
      pagination: {
        pageSize: 5,
        pageIndex: 0,
      },
      density: 'compact',
    },
    enableColumnFilters: true,
    enableFilters: true,
    enableColumnActions: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,
    enablePagination: true,
    paginationDisplayMode: 'pages',
    muiTableHeadCellProps: {
      sx: { ...tableConfig.muiTableHeadCellProps?.sx }
    },
    muiTableBodyRowProps: {
      sx: { ...tableConfig.muiTableBodyRowProps?.sx }
    },
    muiFilterTextFieldProps: {
      placeholder: 'Filtrar...',
      size: 'small',
      variant: 'outlined',
    },
    renderToolbarAlertBannerContent: ({ groupedAlert, selectedAlert, table }) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginLeft: 1,
        }}>
        {selectedAlert}
        <Tooltip title="Eliminar seleccionados">
          <IconButton
            onClick={() => {
              const selectedRows = table.getSelectedRowModel().rows.map(row => row.index)
              handleDelete(selectedRows);
              table.resetRowSelection();
            }}
          >
            <Delete />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  });

  return (
    <>
      <StyledResolucion.TableContainer>
        <MaterialReactTable table={table} />
      </StyledResolucion.TableContainer>
      <StyledResolucion.ButtonContainer>
        <StyledResolucion.CancelButton
          variant="contained"
          onClick={handleCancelResolucion}
        >
          CANCELAR FORMULARIO
        </StyledResolucion.CancelButton>
        <Button
          disabled={data.length === 0}
          color="primary"
          variant="contained"
          onClick={handleNext}
        >
          SIGUIENTE
        </Button>
      </StyledResolucion.ButtonContainer>
    </>
  );
};

export default TrabajadoresSectorTable;